export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

export function StatusBadge({ status }) {
  const map = {
    Active: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20",
    Approved: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20",
    "Pending Approval": "text-amber-400 bg-amber-500/10 border-amber-500/20",
    Pending: "text-amber-400 bg-amber-500/10 border-amber-500/20",
    Required: "text-amber-400 bg-amber-500/10 border-amber-500/20",
    Rejected: "text-red-400 bg-red-500/10 border-red-500/20",
    Denied: "text-red-400 bg-red-500/10 border-red-500/20",
    Frozen: "text-red-400 bg-red-500/10 border-red-500/20",
    Paused: "text-slate-300 bg-slate-500/10 border-slate-500/20",
    Auto: "text-[#4F8CFF] bg-[#4F8CFF]/10 border-[#4F8CFF]/20",
  };
  const cls = map[status] || "text-slate-300 bg-slate-500/10 border-slate-500/20";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`}>
      {status}
    </span>
  );
}

export function RiskBadge({ risk }) {
  const map = {
    Low: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20",
    Medium: "text-amber-400 bg-amber-500/10 border-amber-500/20",
    High: "text-red-400 bg-red-500/10 border-red-500/20",
  };
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${map[risk] || map.Low}`}>
      {risk}
    </span>
  );
}

export function DemoBadge({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-[#4F8CFF]/25 bg-[#4F8CFF]/10 px-2.5 py-1 text-[10px] font-mono uppercase tracking-[0.18em] text-[#8fb4ff] ${className}`}
      data-testid="demo-data-badge"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-[#4F8CFF]" />
      Demo data
    </span>
  );
}

export function SectionLabel({ children }) {
  return (
    <span className="inline-block text-[11px] font-mono uppercase tracking-[0.22em] text-[#4F8CFF]">
      {children}
    </span>
  );
}
